import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'requiredLabel'
})
export class RequiredLabelPipe implements PipeTransform {

  transform(value: string, required: boolean = true): string {
    console.log('RequiredLabelPipe', value, required);
    return required ? `${value} *` : value;
  }

}
